var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOperationsDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15039 11.04C5.15039 10.4878 5.59811 10.04 6.15039 10.04H15.9203C16.4726 10.04 16.9203 10.4878 16.9203 11.04C16.9203 11.5923 16.4726 12.04 15.9203 12.04H6.15039C5.59811 12.04 5.15039 11.5923 5.15039 11.04Z",
    fill: "#DE350B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.04 2C6.04733 2 2 6.04738 2 11.04C2 16.0327 6.04733 20.0801 11.04 20.0801C16.0326 20.0801 20.08 16.0327 20.08 11.04C20.08 6.04738 16.0326 2 11.04 2ZM0 11.04C0 4.94282 4.94275 0 11.04 0C17.1372 0 22.08 4.94282 22.08 11.04C22.08 17.1373 17.1372 22.0801 11.04 22.0801C4.94275 22.0801 0 17.1373 0 11.04Z",
    fill: "#DE350B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsDelete);
export default __webpack_public_path__ + "static/media/operations-delete.d921310c242c7e15a424b20b03922d8f.svg";
export { ForwardRef as ReactComponent };